import React, { useState, useEffect } from 'react';
import { Save, TestTube, Clock, RefreshCw, FileText } from 'lucide-react';
import { toast } from 'react-toastify';
import api from '../services/api';
import './Configuracoes.css';

const Configuracoes = () => {
  const [configuracoes, setConfiguracoes] = useState({
    ftp_host: '',
    ftp_user: '',
    ftp_password: '',
    ftp_remote_path: '/Duque de Caxias/PARCELAMENTOS',
    ftp_filename: 'PARCELAMENTO.{date}.TXT',
    whatsapp_api_url: '',
    whatsapp_api_token: '',
    horario_agendamento: '08:00'
  });
  const [loading, setLoading] = useState(false);
  const [testandoFtp, setTestandoFtp] = useState(false);
  const [arquivosFtp, setArquivosFtp] = useState([]);
  const [carregandoArquivos, setCarregandoArquivos] = useState(false);

  useEffect(() => {
    carregarConfiguracoes();
  }, []);

  const carregarConfiguracoes = async () => {
    try {
      const response = await api.get('/configuracoes');
      console.log('Configurações carregadas do backend:', response.data);
      setConfiguracoes(prev => ({
        ...prev,
        ...response.data
      }));
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setConfiguracoes(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const salvarConfiguracoes = async () => {
    setLoading(true);
    try {
      await api.post('/configuracoes', configuracoes);
      toast.success('Configurações salvas com sucesso!');
    } catch (error) {
      toast.error('Erro ao salvar configurações: ' + error.response?.data?.detail || error.message);
    } finally {
      setLoading(false);
    }
  };

  const testarFtp = async () => {
    setTestandoFtp(true);
    try {
      await api.post('/testar-ftp');
      toast.success('Conexão FTP testada com sucesso!');
      // Após teste bem-sucedido, carregar arquivos
      carregarArquivosFtp();
    } catch (error) {
      toast.error('Erro na conexão FTP: ' + error.response?.data?.detail || error.message);
    } finally {
      setTestandoFtp(false);
    }
  };

  const carregarArquivosFtp = async () => {
    setCarregandoArquivos(true);
    try {
      const response = await api.get('/arquivos-ftp');
      setArquivosFtp(response.data.arquivos || []);
    } catch (error) {
      console.error('Erro ao carregar arquivos FTP:', error);
      toast.error('Erro ao carregar arquivos: ' + error.response?.data?.detail || error.message);
    } finally {
      setCarregandoArquivos(false);
    }
  };

  const agendarProcessamento = async () => {
    try {
      console.log('Horário sendo enviado:', configuracoes.horario_agendamento);
      console.log('Tipo do horário:', typeof configuracoes.horario_agendamento);
      
      if (!configuracoes.horario_agendamento) {
        toast.error('Por favor, selecione um horário');
        return;
      }
      
      await api.post('/agendar-processamento', { horario: configuracoes.horario_agendamento });
      toast.success(`Processamento agendado para ${configuracoes.horario_agendamento}!`);
    } catch (error) {
      console.error('Erro detalhado:', error.response?.data);
      console.error('Detail completo:', JSON.stringify(error.response?.data?.detail));
      toast.error('Erro ao agendar processamento: ' + (error.response?.data?.detail || error.message));
    }
  };

  return (
    <div className="container">
      <div className="configuracoes-header">
        <h1 className="configuracoes-page-title">Configurações</h1>
        <p className="configuracoes-page-subtitle">
          Configure as credenciais e parâmetros do sistema
        </p>
      </div>

      <div className="configuracoes-grid">
        <div className="configuracoes-card">
          <h2 className="configuracoes-card-title">Configurações FTP</h2>
          
          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">Host do FTP</label>
            <input
              type="text"
              name="ftp_host"
              value={configuracoes.ftp_host}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="ftp.exemplo.com"
            />
          </div>

          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">Usuário</label>
            <input
              type="text"
              name="ftp_user"
              value={configuracoes.ftp_user}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="usuario"
            />
          </div>

          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">Senha</label>
            <input
              type="password"
              name="ftp_password"
              value={configuracoes.ftp_password}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="senha"
            />
          </div>

          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">Caminho Remoto</label>
            <input
              type="text"
              name="ftp_remote_path"
              value={configuracoes.ftp_remote_path}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="/caminho/para/arquivo"
            />
          </div>

          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">Nome do Arquivo</label>
            <input
              type="text"
              name="ftp_filename"
              value={configuracoes.ftp_filename}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="dados.txt"
            />
          </div>

          <div className="configuracoes-button-group">
            <button 
              className="btn btn-secondary"
              onClick={testarFtp}
              disabled={testandoFtp}
            >
              {testandoFtp ? (
                <>
                  <div className="loading"></div>
                  Testando...
                </>
              ) : (
                <>
                  <TestTube size={18} />
                  Testar Conexão FTP
                </>
              )}
            </button>
            
            {arquivosFtp.length > 0 && (
              <button 
                className="configuracoes-refresh-button"
                onClick={carregarArquivosFtp}
                disabled={carregandoArquivos}
              >
                {carregandoArquivos ? (
                  <>
                    <div className="loading"></div>
                    Atualizando...
                  </>
                ) : (
                  <>
                    <RefreshCw size={18} />
                    Atualizar Lista
                  </>
                )}
              </button>
            )}
          </div>
        </div>

        <div className="configuracoes-card">
          <h2 className="configuracoes-card-title">Configurações WhatsApp</h2>
          
          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">URL da API WhatsApp</label>
            <input
              type="url"
              name="whatsapp_api_url"
              value={configuracoes.whatsapp_api_url}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="https://api.whatsapp.com/send"
            />
          </div>

          <div className="configuracoes-form-group">
            <label className="configuracoes-form-label">Token da API</label>
            <input
              type="password"
              name="whatsapp_api_token"
              value={configuracoes.whatsapp_api_token}
              onChange={handleInputChange}
              className="configuracoes-form-input"
              placeholder="seu_token_aqui"
            />
          </div>

          <div className="configuracoes-alert-info">
            <p><strong>Dica:</strong> Para usar a API do WhatsApp Business, você precisará de uma conta verificada e configurar webhooks.</p>
          </div>
        </div>
      </div>

      {arquivosFtp.length > 0 && (
        <div className="configuracoes-card">
          <h2 className="configuracoes-card-title">
            <FileText size={20} className="inline mr-2" />
            Arquivos Disponíveis no FTP
          </h2>
          
          <div className="configuracoes-arquivos-list">
            <p className="text-sm text-gray-600 mb-4">
              {arquivosFtp.length} arquivo(s) de parcelamento encontrado(s)
            </p>
            
            <div className="configuracoes-table-container">
              <table className="configuracoes-table">
                <thead>
                  <tr>
                    <th>Arquivo</th>
                    <th>Data/Hora</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {arquivosFtp.slice(0, 10).map((arquivo, index) => {
                    // Extrair data do nome do arquivo
                    const match = arquivo.match(/PARCELAMENTO\.(\d{8})(\d{6})\.TXT/);
                    let dataFormatada = arquivo;
                    let isHoje = false;
                    
                    if (match) {
                      const [, data, hora] = match;
                      const ano = data.substring(0, 4);
                      const mes = data.substring(4, 6);
                      const dia = data.substring(6, 8);
                      const horaStr = hora.substring(0, 2);
                      const minuto = hora.substring(2, 4);
                      const segundo = hora.substring(4, 6);
                      
                      dataFormatada = `${dia}/${mes}/${ano} às ${horaStr}:${minuto}:${segundo}`;
                      
                      // Verificar se é hoje
                      const hoje = new Date().toISOString().slice(0, 10).replace(/-/g, '');
                      isHoje = data === hoje;
                    }
                    
                    return (
                      <tr key={index} className={isHoje ? 'bg-green-50' : ''}>
                        <td>
                          <div className="flex items-center gap-2">
                            <FileText size={16} className="text-blue-600" />
                            <span className="font-mono text-sm">{arquivo}</span>
                          </div>
                        </td>
                        <td className="text-sm">{dataFormatada}</td>
                        <td>
                          {isHoje ? (
                            <span className="status-badge status-success">
                              Arquivo de Hoje
                            </span>
                          ) : (
                            <span className="status-badge status-warning">
                              Arquivo Antigo
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            
            {arquivosFtp.length > 10 && (
              <p className="text-sm text-gray-500 mt-2">
                Mostrando os 10 arquivos mais recentes de {arquivosFtp.length} total
              </p>
            )}
          </div>
        </div>
      )}

      <div className="configuracoes-card">
        <h2 className="configuracoes-card-title">Agendamento Automático</h2>
        
        <div className="configuracoes-form-group">
          <label className="configuracoes-form-label">Horário de Execução Diária</label>
          <input
            type="time"
            name="horario_agendamento"
            value={configuracoes.horario_agendamento}
            onChange={handleInputChange}
            className="configuracoes-form-input"
            style={{ maxWidth: '200px' }}
          />
          <small className="text-gray-600">
            O sistema executará automaticamente todos os dias neste horário
          </small>
        </div>

        <button 
          className="btn btn-primary"
          onClick={agendarProcessamento}
        >
          <Clock size={18} />
          Agendar Processamento
        </button>
      </div>

      <div className="configuracoes-card">
        <button 
          className="btn btn-success"
          onClick={salvarConfiguracoes}
          disabled={loading}
        >
          {loading ? (
            <>
              <div className="loading"></div>
              Salvando...
            </>
          ) : (
            <>
              <Save size={18} />
              Salvar Todas as Configurações
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Configuracoes;
